// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './Components/route/PrivateRoute';

import Login from './Components/pages/Login/login';
import Layout from './Components/layouts/Layout';
import Dashboard from './Components/layouts/Dashboard';
import Users from './Components/pages/Users/Users';
import AddUser from './Components/pages/Users/AddUser';
import Settings from './Components/pages/companysetting/Settings';
import RoleManager from './Components/GeneralMasterpage/Role/RoleManager';
import AddEditRolePage from './Components/GeneralMasterpage/Role/AddRoleModal';
import CountryList from './Components/GeneralMasterpage/Country/CountryList';
import AddCountry from './Components/GeneralMasterpage/Country/AddCountry';
import StateList from './Components/GeneralMasterpage/State/StateList';
import AddState from './Components/GeneralMasterpage/State/AddStateModal';
import CityList from './Components/GeneralMasterpage/City/CityList';
import AddCity from './Components/GeneralMasterpage/City/AddCity';
import CategoryList from './Components/GeneralMasterpage/Category/Main-CategoryList';
import AddEditCategory from './Components/GeneralMasterpage/Category/AddEditMainCategory';
import Unauthorized from './Components/pages/Unauthorized/Unauthorized';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import VariantNameList from './Components/GeneralMasterpage/Variant/VariantNameList';
import AddVariantName from './Components/GeneralMasterpage/Variant/AddVariantName';
import VariantValueList from './Components/GeneralMasterpage/Variant/VariantValueList';
import AddVariantValue from './Components/GeneralMasterpage/Variant/AddVariantValue';

import ProductList from './Components/pages/Product/ProductList';
import AddEditProduct from './Components/pages/Product/AddProduct';
import MessageList from './Components/pages/Message/MessageList';
import MessageForm from './Components/pages/Message/MessageForm';
import OrderInvoice from './Components/pages/Order/OrderInvoice';
import BannerControl from './Components/pages/Banner/Banner';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <PrivateRoute requiredPermissions="view_Dashboard">
            <Layout><Dashboard /></Layout>
          </PrivateRoute>
        } />

        {/* User Management */}
        <Route path="/users" element={
          <PrivateRoute requiredPermissions="read_User">
            <Layout><Users /></Layout>
          </PrivateRoute>
        } />
        <Route path="/add-user" element={
          <PrivateRoute requiredPermissions="create_User">
            <Layout><AddUser /></Layout>
          </PrivateRoute>
        } />

        {/* Role Management */}
        <Route path="/role" element={
          <PrivateRoute requiredPermissions="read_RoleAccessControl">
            <Layout><RoleManager /></Layout>
          </PrivateRoute>
        } />
        <Route path="/roles/add" element={
          <PrivateRoute requiredPermissions="create_RoleAccessControl">
            <Layout><AddEditRolePage /></Layout>
          </PrivateRoute>
        } />
        <Route path="/roles/edit/:id" element={
          <PrivateRoute requiredPermissions="update_RoleAccessControl">
            <Layout><AddEditRolePage /></Layout>
          </PrivateRoute>
        } />

        {/* Settings */}
        <Route path="/settings" element={
          <PrivateRoute requiredPermissions="read_CompanySettings">
            <Layout><Settings /></Layout>
          </PrivateRoute>
        } />

        {/* Country Management */}
        <Route path="/country" element={
          <PrivateRoute requiredPermissions="read_Country">
            <Layout><CountryList /></Layout>
          </PrivateRoute>
        } />
        <Route path="/country/add" element={
          <PrivateRoute requiredPermissions="create_Country">
            <Layout><AddCountry /></Layout>
          </PrivateRoute>
        } />
        <Route path="/country/:id" element={
          <PrivateRoute requiredPermissions="update_Country">
            <Layout><AddCountry /></Layout>
          </PrivateRoute>
        } />

        {/* State Management */}
        <Route path="/state" element={
          <PrivateRoute requiredPermissions="read_State">
            <Layout><StateList /></Layout>
          </PrivateRoute>
        } />
        <Route path="/add-state" element={
          <PrivateRoute requiredPermissions="create_State">
            <Layout><AddState /></Layout>
          </PrivateRoute>
        } />
        <Route path="/add-state/:id" element={
          <PrivateRoute requiredPermissions="update_State">
            <Layout><AddState /></Layout>
          </PrivateRoute>
        } />

        {/* City Management */}
        <Route path="/city" element={
          <PrivateRoute requiredPermissions="read_City">
            <Layout><CityList /></Layout>
          </PrivateRoute>
        } />
        <Route path="/add-city" element={
          <PrivateRoute requiredPermissions="create_City">
            <Layout><AddCity /></Layout>
          </PrivateRoute>
        } />
        <Route path="/edit-city/:id" element={
          <PrivateRoute requiredPermissions="update_City">
            <Layout><AddCity /></Layout>
          </PrivateRoute>
        } />

        {/* Category Management */}
        <Route path="/category" element={
          <PrivateRoute requiredPermissions="read_Category">
            <Layout><CategoryList /></Layout>
          </PrivateRoute>
        } />
        <Route path="/add-category" element={
          <PrivateRoute requiredPermissions="create_Category">
            <Layout><AddEditCategory /></Layout>
          </PrivateRoute>
        } />
        <Route path="/edit-category/:id" element={
          <PrivateRoute requiredPermissions="update_Category">
            <Layout><AddEditCategory /></Layout>
          </PrivateRoute>
        } />

        {/* variantName */}
        <Route path="/variant-name" element={
          <PrivateRoute requiredPermissions="read_VariantName">
            <Layout><VariantNameList /></Layout>
          </PrivateRoute>
        } />
        <Route path="/add-variant" element={
          <PrivateRoute requiredPermissions="create_VariantName">
            <Layout><AddVariantName /></Layout>
          </PrivateRoute>
        } />
        <Route path="/edit-variant/:id" element={
          <PrivateRoute requiredPermissions="update_VariantName">
            <Layout><AddVariantName /></Layout>
          </PrivateRoute>
        } />

        {/* variantValues */}
        <Route path="/variant-values" element={
          <PrivateRoute requiredPermissions="read_VariantValue">
            <Layout><VariantValueList /></Layout>
          </PrivateRoute>
        } />

        <Route path="/add-variant-value" element={
          <PrivateRoute requiredPermissions="create_VariantValue">
            <Layout><AddVariantValue /></Layout>
          </PrivateRoute>
        } />
        <Route path="/edit-variant-value/:id" element={
          <PrivateRoute requiredPermissions="update_VariantValue">
            <Layout><AddVariantValue /></Layout>
          </PrivateRoute>
        } />
         
          {/* product */}
          <Route path="/Product" element={
          <PrivateRoute requiredPermissions="read_Product">
            <Layout><ProductList /></Layout>
          </PrivateRoute>
        } />
       

          <Route path="/AddProduct" element={
          <PrivateRoute requiredPermissions="create_Product">
            <Layout><AddEditProduct /></Layout>
          </PrivateRoute>
        } />

         <Route path="/editproduct/:id" element={
          <PrivateRoute requiredPermissions="update_Product">
            <Layout><AddEditProduct /></Layout>
          </PrivateRoute>
        } />

        {/* Message */}
        <Route path="/Message" element={
          <PrivateRoute requiredPermissions="read_Message">
            <Layout><MessageList /></Layout>
          </PrivateRoute>
        } />

         <Route path="/AddMessage" element={
          <PrivateRoute requiredPermissions="create_Message">
            <Layout><MessageForm /></Layout>
          </PrivateRoute>
        } />

        <Route path="/AddMessage" element={
          <PrivateRoute requiredPermissions="create_Message">
            <Layout><MessageForm /></Layout>
          </PrivateRoute>
        } />
        
        <Route path="/Order" element={
          <PrivateRoute requiredPermissions="read_Order">
            <Layout><OrderInvoice /></Layout>
          </PrivateRoute>
        } />

        <Route path="/Banner" element={
          <PrivateRoute requiredPermissions="read_Banner">
            <Layout><BannerControl /></Layout>
          </PrivateRoute>
        } />


        {/* Catch-All Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
